export const PUBLISH_FIELD_HEADING_HEIGHT = 47;
